import request from '../request';

/**
 * Fetches all actions where actionPerformed is true.
 * If a clientId is provided, it includes clientId as a query parameter.
 * @param {string} [clientId] - Optional client ID to filter actions.
 * @returns {Promise<Object>} - A Promise that resolves to the API response data.
 * @throws {Error} - If the API request fails, an Error is thrown.
 */
export const getPerformedActions = async ({ clientId }) => {
    try {
        const endpoint = clientId
            ? `/action-tracking/performed-actions?clientId=${clientId}`
            : '/action-tracking/performed-actions';

        const { data, status } = await request('GET', endpoint);
        return { data, status };
    } catch (error) {
        throw new Error(`Failed to fetch performed actions: ${error.message}`);
    }
};

export default getPerformedActions;
